import { erorrMessages } from "../pages/donate/constants/errorMessages";

const errorKeys = {
    incorrect_cvc: "payment.incorrect_cvc",
    insufficient_funds: "payment.card_declined.insufficient_funds"
};

export const getErrorMessage = errorKey => {
    if (errorKey === errorKeys.incorrect_cvc) {
        return erorrMessages.IncorrectCVC;
    }

    if (errorKey === errorKeys.insufficient_funds) {
        return erorrMessages.InsufficientFunds;
    }

    return erorrMessages.ProcessingError;
};